import React from 'react';
import { ClockIcon, AlertCircleIcon } from 'lucide-react';
import { useDarkClasses } from '../../../hooks/useDarkClasses';
import { COMMON_TIMEZONES } from '../../../data/eventSchema';
import type { EM } from './useEventManager';
export const DateTimeSection: React.FC<{
  em: EM;
}> = ({
  em
}) => {
  const dk = useDarkClasses();
  const {
    formData,
    updateField
  } = em;
  const isMultiDay = formData.startDate && formData.endDate && formData.startDate !== formData.endDate;
  return <div className={`p-6 rounded-xl shadow-sm ${dk.card}`} data-id="element-18523" data-mp="1biguxgkspmcr">
      <h2 className={`text-lg font-bold mb-4 flex items-center ${dk.textHeading}`} data-id="element-18524" data-mp="1bk1p353773a3">
        <ClockIcon className="w-5 h-5 mr-2 text-purple-500" data-id="element-18525" data-mp="xoftgf2gll8p" />
        Date & Time
      </h2>

      <div className="space-y-4" data-id="element-18526" data-mp="12pvdq4wtbnq1">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-18527" data-mp="nsmjn3g4k5um">
          <div data-id="element-18528" data-mp="nt4kyehn9a9e">
            <label className={`block text-sm font-medium mb-1 ${dk.textSecondary}`} data-id="element-18529" data-mp="nup8vl9gduya">
              Start Date <span className="text-red-500" data-id="element-18530" data-mp="qzu74uvn80fr">*</span>
            </label>
            <input type="date" value={formData.startDate || ''} onChange={e => updateField('startDate', e.target.value)} className={`w-full p-2 rounded-md border ${dk.inputOnCard}`} data-id="element-18531" data-mp="r26p381eiast" />
          </div>
          <div data-id="element-18532" data-mp="vzycppv0jar7">
            <label className={`block text-sm font-medium mb-1 ${dk.textSecondary}`} data-id="element-18533" data-mp="vxc6punrt3b3">
              Start Time <span className="text-red-500" data-id="element-18534" data-mp="3ardeonqih4w">*</span>
            </label>
            <input type="time" value={formData.startTime || ''} onChange={e => updateField('startTime', e.target.value)} className={`w-full p-2 rounded-md border ${dk.inputOnCard}`} data-id="element-18535" data-mp="38ogrls2tpr7" />
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-18536" data-mp="3kppwckwr063e">
          <div data-id="element-18537" data-mp="3gqh1tdtvw46s">
            <label className={`block text-sm font-medium mb-1 ${dk.textSecondary}`} data-id="element-18538" data-mp="3gomczofhrrxf">
              End Date <span className="text-red-500" data-id="element-18539" data-mp="1joroljemfffd">*</span>
            </label>
            <input type="date" value={formData.endDate || ''} onChange={e => updateField('endDate', e.target.value)} className={`w-full p-2 rounded-md border ${dk.inputOnCard}`} data-id="element-18540" data-mp="1on2ytv8tvry4" />
          </div>
          <div data-id="element-18541" data-mp="10qfd3r08ltgm">
            <label className={`block text-sm font-medium mb-1 ${dk.textSecondary}`} data-id="element-18542" data-mp="10qp8ju41wstp">
              End Time <span className="text-red-500" data-id="element-18543" data-mp="15q1pxzc5l7ow">*</span>
            </label>
            <input type="time" value={formData.endTime || ''} onChange={e => updateField('endTime', e.target.value)} className={`w-full p-2 rounded-md border ${dk.inputOnCard}`} data-id="element-18544" data-mp="1antsroec6e7v" />
          </div>
        </div>

        {isMultiDay && <div className={`flex items-center p-3 rounded-lg text-sm ${em.darkMode ? 'bg-indigo-900/30 text-indigo-300' : 'bg-indigo-50 text-indigo-700'}`} data-id="element-18545" data-mp="2r1trwx5cxzu2">
            <AlertCircleIcon className="w-4 h-4 mr-2 flex-shrink-0" data-id="element-18546" data-mp="agez19iousji" />
            This is a multi-day event. The times above apply to the entire
            duration.
          </div>}

        <div data-id="element-18547" data-mp="qd90c6rz01y">
          <label className={`block text-sm font-medium mb-1 ${dk.textSecondary}`} data-id="element-18548" data-mp="qve7ybf0om0">
            Time Zone <span className="text-red-500" data-id="element-18549" data-mp="3rxpsixv4rpl1">*</span>
          </label>
          <select value={formData.timezone || ''} onChange={e => updateField('timezone', e.target.value)} className={`w-full p-2 rounded-md border ${dk.inputOnCard}`} data-id="element-18550" data-mp="3nv2zitmq3ym9">
            <option value="" data-id="element-18551" data-mp="3dxf3m0ddsl2i">Select Time Zone</option>
            {COMMON_TIMEZONES.map(tz => <option key={tz.value} value={tz.value} data-id="element-18552" data-mp="1h5508ls6q19o">
                {tz.label} ({tz.value})
              </option>)}
          </select>
          <p className={`mt-1 text-xs ${dk.textFaint}`} data-id="element-18553" data-mp="1c3fqd9gp7tn6">
            Event times will be automatically converted to the reader's local
            time zone.
          </p>
        </div>
      </div>
    </div>;
};